import React from 'react';
import Chip from '@mui/material/Chip';
import { PassOut, PassStatus } from '../../api';
import type { PassOrderPageData } from '../../api/models/PassOrderPageData';
import { hasPassStarted, isMembership, isPassExpired } from '../utils/passUtils';

/**
 * The one status chip for a pass, shared by the dashboard card and the detail view. Memberships get
 * their own states first: a paused or ending membership is neither "active" nor "expired", and the
 * punch-count states never apply to them.
 */
export const getStatusChip = (
  pass: PassOut,
  numPunches: number | null,
  passOrderPage: PassOrderPageData | undefined,
  t: (key: string) => string,
) => {
  const membership = isMembership(passOrderPage);
  const expired = isPassExpired(pass, passOrderPage);

  if (membership && pass.status === PassStatus.SUSPENDED) {
    return <Chip label={t('manage_passes.membership.status.paused')} color="warning" size="small" />;
  }
  if (expired) {
    return <Chip label={t('manage_passes.pass.status.expired')} color="error" size="small" />;
  }
  if (membership && pass.auto_renew === false) {
    return <Chip label={t('manage_passes.membership.status.ending')} color="default" size="small" />;
  }

  if (pass.status === PassStatus.ACTIVE && !hasPassStarted(pass)) {
    return <Chip label={t('manage_passes.pass.status.notYetActive')} color="warning" size="small" />;
  }
  if (pass.status === PassStatus.ACTIVE) {
    return <Chip label={t('manage_passes.pass.status.active')} color="success" size="small" />;
  }
  if (pass.status === PassStatus.PENDING_PAYMENT) {
    return <Chip label={t('manage_passes.pass.status.pending')} color="warning" size="small" />;
  }
  return null;
};
